<template>
    <div>
        <rea-loader :loading="loading"></rea-loader>
        <v-server-table :url="apiUrl" :columns="columns" :options="computedOptions" @loaded="finalizeLoading"
                        @loading="showReaLoader"
                        class="trigger relations-table" ref="table" v-bind="$attrs">
            <template slot="name" slot-scope="props">
                <router-link :to="{ name: 'admin.relations.view', params: { id: props.row.id }}">{{
                        props.row.full_name
                    }}
                </router-link>
            </template>
            <template slot="organisation" slot-scope="props">
                <b-badge pill v-if="props.row.organisation" variant="primary">{{
                        props.row.organisation.name
                    }}
                </b-badge>
                <span v-else>-</span>
            </template>
            <template slot="type" slot-scope="props">
                <b-badge pill variant="primary">{{ props.row.type ? props.row.type.name : '' }}</b-badge>
            </template>
            <template slot="email" slot-scope="props">
                <a :href="props.row.email" v-mail-to>{{ props.row.email }}</a>
            </template>
            <template slot="phone_number" slot-scope="props">
                <a v-if="props.row.phone_number !== null" :href="props.row.full_phone_number"
                   v-tel>{{ props.row.full_phone_number }}</a>
                <span v-if="props.row.phone_number === null">-</span>
            </template>
            <template slot="mobile" slot-scope="props">
                <a v-if="props.row.mobile !== null" :href="props.row.full_mobile" v-tel>{{ props.row.full_mobile }}</a>
                <span v-if="props.row.mobile === null">-</span>
            </template>
            <template slot="city" slot-scope="props">
                <div v-if="props.row.addresses && props.row.addresses.length > 0">
                    <span class="pointer" @click="tooltip(props.row.addresses[0])">{{ props.row.addresses[0].city }} <i
                        class="fa fa-info-circle" aria-hidden="true"></i></span>
                    <div class="thomastip" v-if="showToolTip(props.row.addresses[0])">
                        <address-helper :address="props.row.addresses[0]"></address-helper>
                    </div>
                </div>
                <span v-else="">-</span>
            </template>
            <template slot="filter__type">
                <multi-select :options="types" :loading="!types" :deselectLabel="''"
                              :selectLabel="''" :selectedLabel="uLang('app.select')"
                              label="name" :placeholder="uLang('app.select_an_option')" @input="searchType"
                              track-by="name"/>
            </template>
        </v-server-table>
    </div>
</template>

<script>
import Actions from '~/components/tables/admin/relation/actions'
import {TableMixin, TooltipMixin} from '~/mixins'
import MultiSelect from 'vue-multiselect/src/index'
import {Event as VueTableEvent} from 'vue-tables-2';
import {ReaLoader} from '~/components/helpers'

export default {
    name: 'index',
    mixins: [TableMixin, TooltipMixin],
    components: {
        'multi-select': MultiSelect,
        ReaLoader
    },

    props: {
        apiUrl: {
            type: String,
            default: '/api/admin/relations/table',
        },
        columns: {
            type: Array,
            default: () => [
                'name',
                'organisation',
                'type',
                'email',
                'phone_number',
                'mobile',
                'city',
                'actions'
            ],
        },
        filterable: {
            type: Array,
            default: () => [
                'name',
                'organisation',
                'email',
                'phone_number',
                'mobile',
                'city'
            ]
        },
        additionalOptions: {
            type: Object,
            default: () => {
                return {}
            }
        },
        rowsPerPage: {
            type: String,
            default: "90"
        }
    },

    data() {
        return {
            hasTouched: false,
            templates: {
                    actions: Actions,
                },
                types: [],
            loading: true
            }
        },

        computed: {
            computedOptions() {
                const perPage = Number.parseInt(this.rowsPerPage, 10);
                return Object.assign({}, this.options, this.additionalOptions, {
                    perPage,
                    headings: {
                        name: this.uLang('app.name'),
                        organisation: this.uLang('app.organisation'),
                        type: this.uLang('app.type'),
                        email: this.uLang('app.email'),
                        phone_number: this.uLang('app.phone_number'),
                        mobile: this.uLang('app.mobile'),
                        city: this.uLang('app.city'),
                        actions: this.uLang('app.actions'),
                    },
                    customFilters: [
                        'type',
                    ],
                });
            }
        },

        mounted() {
            this.$nextTick(() => {
                if (this.$refs.table) {
                    this.$refs.table.setLimit(Number.parseInt(this.rowsPerPage, 10));
                    this.$refs.table.refresh();
                }
            });
        },

        created: function () {
            this.options.perPage = Number.parseInt(this.rowsPerPage, 10);
            this.retrieveTypes();
        },

        methods: {
            async retrieveTypes() {
                const {data} = await window.axios.get(route('types.index'));

                // Quick, hacky fix to filter types in case we are trajectory manager
                if($hasRole('trajectory_manager')) {
                    let allowed_types = ['candidate', 'client'];
                    return this.types = data.filter(type => {
                        return allowed_types.includes(type.system_name) || allowed_types === [];
                    })
                }

                this.types = data;
            },

            searchType(type) {
                let typeName = type !== null ? type.name : '';
                this.$refs.table.query.type = typeName;
                this.$refs.table.refresh();
            },

            showReaLoader() {
                this.loading = true
            },

            finalizeLoading() {
                this.addToolTips()
                this.loading = false
            }
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        }
    }
</script>

<style lang="scss">
.relations-table .VueTables__table {
    min-height: 300px;
}
</style>
